// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputText_inputText__tRCdy","inputMessage":"inputText_inputMessage__21SvS"};